export class GetOrderItemDetailsRequest {
  orderNo: string = null;
  itemNo: string = null;
  scenarioId: string = null;

  constructor(orderNumber?, itemNumber?, scenarioId?) {
    this.orderNo = orderNumber;
    this.itemNo = itemNumber;
    this.scenarioId = scenarioId ;
  }

  toQueryString() {
    return `/${this.orderNo}/${this.itemNo}?scenarioId=${this.scenarioId}`
  }

}